import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetOmeMeetOrgUnitEntryPurchaseByIdData = (omeMeetOrgUnitEntryPurchaseId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const omeMeetOrgUnitEntryPurchaseIdForUrl = omeMeetOrgUnitEntryPurchaseId ? encodeURIComponent(omeMeetOrgUnitEntryPurchaseId) : 'NaN';
    const url = `/OmeMeetOrgUnitEntryPurchase/${omeMeetOrgUnitEntryPurchaseIdForUrl}`;
    MeetHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default GetOmeMeetOrgUnitEntryPurchaseByIdData;